module.exports = __webpack_public_path__ + "img/3-white.4559719f.png";